import * as gs from './_csGbl';
import * as f from './_cmFTH';

import * as hf from './_hf';
import * as ht from './_ht';
import * as ihd from 'src/ihd';

export const ilz_70z = () => ({ // 新規登録を考慮し、毎回新規生成
  _70rz: {},
}) as ht.dz;

export const crt_70z = async () => {
  const _gUserz = gs.useUserz();
  const __70z = ilz_70z();
  hf.udtDz(__70z._70rz, {
    ... ihd.i('_70r'),
    _70r_31r1f: _gUserz.crt._31rz._fst,
  });
  return __70z;
};

export const load_70rLsAsync = async (pz: {
  cdn: ht.s,
}) => {
  let _cdn = f.vdd();
  if (pz.cdn) _cdn += ` AND (${pz.cdn})`;
  const _ls = await f.loadLsAsync({
    tgt: '_70rs',
    cdn: _cdn,
    fld: '*',
    tailz: {
      odr: '_70rd1100s desc',
    }
  });
  return _ls;
};

export const load_70rDzAsync = async (pz: {
  _70r_fst: ht.n,
  cdn: ht.s,
}) => {
  let _cdn = f.vdd() + ` AND _fst=${pz._70r_fst}`;
  if (pz.cdn) _cdn += ` AND (${pz.cdn})`;
  const _dz = await f.loadDzAsync({
    tgt: '_70rs',
    cdn: _cdn,
    fld: '*',
    lwrz: {
      _10rs: {
        tgt: '_10rs',
        cdn: f.vdd() + ` AND _key = {_10r_key}`,
        rlcz: {
          _10r_key: '_70rs._70r_10r1k',
        }
      }
    },
  });
  // hf.l(`_cv_70___Mz 55: ${hf.s(_dz)}`);
  return {
    _70rz: { ... _dz, cldz: undefined },
    _10rz: hf.get1(_dz.cldz?._10rs, {}),
  };
};

export const save_70rDzAsync = async (pz: {
  _70z: ht.dz,
  sPz?: ht.dz,
}) => {
  const _dz = await f.ugdDzAsync({
    tgt: '_70rs',
    dz: {
      ... pz._70z._70rz,
    },
    atrs:
      pz._70z._70rz._dlt != 1 ? 
      [].concat(
        ihd.f('_icn', '_70r').atrs, // ID
      )
      : undefined,
  });
  if (pz.sPz) pz.sPz.set({
    _70r_fst: _dz._fst,
  })
  return {
    _70rz: { ... _dz, cldz: undefined },
  };
};
